import { myIcons } from "@/utils/icons";
import { t } from "i18next";

export const Footer = () => {
    return (
        <footer style={{
            backgroundColor: "#1a1a1a",
            color: "#f5f5f5",
            padding: "20px 40px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px",
            margin: 0
        }}>
            {/* Sol kısım */}
            <div style={{ fontSize: "1.1rem" }}>
                Yasin YILDIZ
            </div>

            {/* Orta kısım */}
            <div style={{ fontSize: "0.9rem", opacity: 0.8 }}>
                © {new Date().getFullYear()} {t('footer-copyright')}
            </div>

            {/* Sağ kısım */}
            <div className="socials"
                style={{
                    display: 'flex',
                    gap: '10px'
                }}
            >
                <a href="https://github.com/yasinyildizdev" target="_blank" rel="noopener noreferrer">
                    <img src={myIcons.socials.github} alt="GitHub" />
                </a>
                <a href="https://www.linkedin.com/in/yasin-yildiz-218b34218/" target="_blank" rel="noopener noreferrer">
                    <img src={myIcons.socials.linkedin} alt="LinkedIn" />
                </a>
                <a href="https://google.com" target="_blank" rel="noopener noreferrer">
                    <img src={myIcons.socials.google} alt="Google" />
                </a>
                <a href="https://instagram.com/08yasins" target="_blank" rel="noopener noreferrer">
                    <img src={myIcons.socials.instagram} alt="Instagram" />
                </a>
            </div>
        </footer>
    );
};
